import React, { FC, ReactElement, ReactNode } from 'react'

type Props = {
    disabled?: boolean
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
    className?: string
    children: ReactNode
}

/**
 * Rounded buttons as per the preference of Mark Watson.
 *
 * @param disabled - boolean - Whether the button is disabled or not.
 * @param onClick - function - The function to call when the button is clicked.
 * @param className - string - The class name to add to the button.
 * @param children - ReactNode - The content of the button.
 */
export const WatsonButton: FC<Props> = ({ className, children, onClick, disabled }: Props): ReactElement => (
    <button
        className={`watson-button ${className} ${disabled ? 'disabled' : ''}`}
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </button>
)
